export default __webpack_public_path__ + "static/media/fp-white.922cc8a3.svg";